import { AppState } from '@store/app.store';
import { createSelector } from '@ngrx/store';

import { themeAdapter } from '@store/reducer/theme.reducer';

export const selectFeature = (state: AppState) => state.theme;

export const selectIsLoadingTheme = createSelector(
  selectFeature,
  state => state.isLoading
);

export const selectTheme = createSelector(
  selectFeature,
  themeAdapter.getSelectors().selectAll
);

export const selectThemeError = createSelector(
  selectFeature,
  state => state.error
);
